/** Planes Nukli — espejo simplificado de @nukli/shared/plans para la landing. */
export const PLAN_PRICE_EUR = {
  free: 0,
  pro: 20,
  pro_plus: 40,
  ultra: 99,
};

export const PLAN_PRICE_EUR_YEAR = {
  free: 0,
  pro: 200,
  pro_plus: 400,
  ultra: 990,
};

export const PAID_PLANS = ['pro', 'pro_plus', 'ultra'];
export const ALL_PLANS = ['free', 'pro', 'pro_plus', 'ultra'];

export function planPrice(plan, interval) {
  return interval === 'year' ? PLAN_PRICE_EUR_YEAR[plan] : PLAN_PRICE_EUR[plan];
}

export function annualSavingPercent() {
  return Math.round((ANNUAL_FREE_MONTHS / 12) * 100);
}

export const ANNUAL_FREE_MONTHS = 2;
